import { WidgetPositioning, WidgetType } from "@src/types/dashboards";

/** Entries a `multiple-text-values` widget can hold. Mirrors the BE
 *  template's `encoding.min_roles` / `max_roles`; the editor enforces the
 *  same pair by hiding the × at the floor and the + at the ceiling. */
export const MULTIPLE_TEXT_VALUES_MIN_ENTRIES = 1;
export const MULTIPLE_TEXT_VALUES_MAX_ENTRIES = 10;

/** Grid rows the tile spends on itself (padding + border) rather than on
 *  entries. One grid row is 30px — `CELL_HEIGHT` in dashboard-tile-grid. */
export const MULTIPLE_TEXT_VALUES_CHROME_ROWS = 1;

/** Tile height, in grid rows, for a widget holding `entryCount` entries.
 *  Called by the drawer when it writes the tile's positioning on save, and
 *  by the size table for the pre-save seed. Clamped to the entry floor and
 *  ceiling so a stale row count can never produce an unsized tile. */
export const multipleTextValuesHeight = (entryCount: number): number =>
  Math.min(
    Math.max(entryCount, MULTIPLE_TEXT_VALUES_MIN_ENTRIES),
    MULTIPLE_TEXT_VALUES_MAX_ENTRIES,
  ) + MULTIPLE_TEXT_VALUES_CHROME_ROWS;

/** The tile's positioning with `h` re-derived from the entry count, so a
 *  save that added or removed entries also resizes the tile. Only
 *  `multiple-text-values` is content-sized — every other type passes
 *  through untouched, so callers can hand this any widget's positioning. */
export const withMultipleTextValuesHeight = (
  type: WidgetType,
  positioning: WidgetPositioning | undefined,
  entryCount: number,
): WidgetPositioning | undefined => {
  if (type !== "multiple-text-values" || !positioning) return positioning;
  return { ...positioning, h: multipleTextValuesHeight(entryCount) };
};
